// extracted by mini-css-extract-plugin
export default {"overlay":"Gf07ab9","overlayText":"Gdf3266"};